<template>
    <div class="wallpaper-categories-list">
        <div class="form is-horizontal">
            <div class="form__group" v-if="showFilters['search']">
                <label class="form__label" for="search" autocomplete="off">{{ __('Search') }}</label>
                <input class="form__control" id="search"
                       v-model="search"
                       v-on:change="getCategories(true)"
            />
            </div>
        </div>

        <router-link class="btn has-margin-b30 is-pulled-left is-primary"
                     v-bind:to="{ name: 'wallpapers.categories.add' }"
        >
            <span class="jam jam-plus"></span> {{ __('Add category') }}
        </router-link>

        <table class="table is-clearfix">
            <thead>
                <tr>
                    <th>
                        <input type="checkbox"
                               v-bind:checked="selectedItems.length == paging.to - paging.from + 1"
                               v-on:click="selectAllItems"
                        />
                    </th>
                    <th>
                        <a class="sort"
                           v-bind:class="{ 'asc' : sort == 'name_desc', 'desc' : sort == 'name_asc' }"
                           v-on:click="sortBy(sort !== 'name_asc' ? 'name_asc' : 'name_desc')"
                                >
                            {{ __('Name') }}
                        </a>
                    </th>
                    <th>{{ __('Actions') }}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="category in categories">
                    <td>
                        <input type="checkbox"
                               v-bind:checked="selectedItems.indexOf(category.id) !== -1"
                               v-on:click="selectItem(category.id)"
                        />
                    </td>
                    <td>{{ category.name }}</td>
                    <td>
                        <router-link
                                v-bind:to="{
                                    name: 'wallpapers.categories.edit',
                                    params: { category: category.id }
                                }"
                        >
                            Edit
                        </router-link>
                        /
                        <a v-on:click="openDeleteConfirmModal('delete-wallpaper-category-' + category.id)">
                            Delete
                        </a>
                        <confirm-modal
                                v-bind:id="'delete-wallpaper-category-' + category.id"
                                v-bind:text="__('Are you sure you wish to delete this category?')"
                        ></confirm-modal>
                    </td>
                </tr>
            </tbody>
        </table>

        <div class="wallpaper-categories-list__bulk-actions" v-if="selectedItems.length > 0">
            <a class="btn is-pulled-left"
               v-on:click="openDeleteConfirmModal('delete-selected-wallpaper-categories')"
                    >
                {{ __('Delete selected') }}
            </a>
            <confirm-modal
                    v-bind:id="'delete-selected-wallpaper-categories'"
                    v-bind:text="__('Are you sure you wish to delete all selected categories?')"
            ></confirm-modal>
        </div>

        <p v-if="!categories">{{ __('Loading categories&hellip;') }}</p>
        <p v-if="categories && categories.length == 0">{{ __('You have no categories.') }}</p>

        <paging v-bind:paging="paging" v-if="showPaging"></paging>
    </div>
</template>

<script>
    import { eventBus } from '../eventBus.js';

    import confirmModal from '../elements/ConfirmModal.vue';
    import paging from '../elements/Paging.vue';

    export default {
        components: {
            confirmModal,
            paging
        },
        created: function () {
            // attach event listeners
            eventBus.$on('confirm', this.handleDelete);
        },
        data: function () {
            return {
                categories: [],
                paging: {
                    current: 1,
                    from: 1,
                    lastPage: 1,
                    perPage: this.showPaging ? 50 : 0,
                    to: 1,
                    total: 0
                },
                search: null,
                selectedItems: [],
                sort: 'name_asc'
            }
        },
        methods: {
            getCategories: function (resetPaging = false) {
                this.categories = [];
                if (resetPaging) {
                    this.paging.current = 1;
                }

                let filters = {};

                if (this.search) {
                    filters.search = this.search;
                }

                let sortBy = 'name';
                let sortOrder = 'asc';

                switch (this.sort) {
                    case 'name_asc':
                        sortBy = 'name';
                        sortOrder = 'asc';

                        break;
                    case 'name_desc':
                        sortBy = 'name';
                        sortOrder = 'desc';

                        break;
                    default:
                        sortBy = this.sort;
                        sortOrder = 'asc';
                }

                eventBus.$emit('show-loader');

                this.$http.get(this.apiUrl + '/wallpapers/categories', {
                    params : {
                        filters: filters,
                        page: this.paging.current,
                        perPage: this.paging.perPage,
                        sortBy: sortBy,
                        sortOrder: sortOrder
                    }
                }).then(function (response) {
                    this.paging.from = response.body.original.from;
                    this.paging.lastPage = response.body.original.last_page;
                    this.paging.to = response.body.original.to;
                    this.paging.total = response.body.original.total;
                    this.categories = response.body.original.data;

                    eventBus.$emit('hide-loader');
                }, function (response) {
                    eventBus.$emit(
                            'show-alert',
                            'error',
                            this.__('There was an error retrieving data from the server.')
                    );

                    eventBus.$emit('hide-loader');
                });
            },
            handleDelete: function (id) {
                let categories = this.categories;
                let deleteCount = 0;

                this.categories.forEach(function (category) {
                    if (
                        id == 'delete-wallpaper-category-' + category.id
                        || (
                            id == 'delete-selected-wallpaper-categories'
                            && this.selectedItems.indexOf(category.id) !== -1
                        )
                    ) {
                        eventBus.$emit('show-loader');

                        this.$http.delete(this.apiUrl + '/wallpapers/categories/' + category.id).then(function (response) {
                            this.paging.to--;
                            this.paging.total--;
                            deleteCount++;

                            if (id == 'delete-selected-startdesk-categories') {
                                if (deleteCount == this.selectedItems.length) {
                                    window.location.reload();
                                }
                            } else {
                                this.categories = categories.filter(function (cat) {
                                    return cat.id != category.id
                                });
                            }

                            eventBus.$emit('hide-loader');
                        }.bind(this), function (response) {
                            eventBus.$emit(
                                    'show-alert',
                                    'error',
                                    this.__('There were some errors sending data to server.')
                            );

                            eventBus.$emit('hide-loader');
                        });

                    }
                }.bind(this));
            },
            init: function () {
                this.getCategories(true);
            },
            openDeleteConfirmModal: function (id) {
                eventBus.$emit('open-modal', id);
            },
            selectAllItems: function () {
                if (this.selectedItems.length == this.paging.to - this.paging.from + 1) {
                    this.selectedItems = [];
                } else {
                    this.categories.forEach(function (category) {
                        this.selectedItems.push(category.id);
                    }.bind(this));
                }
            },
            selectItem: function (id) {
                if (this.selectedItems.indexOf(id) !== -1) {
                    this.selectedItems.splice(this.selectedItems.indexOf(id), 1);
                } else {
                    this.selectedItems.push(id);
                }
            },
            sortBy: function (sort) {
                this.sort = sort;

                this.getCategories(true);
            },
            updatePaging: function (newPage, perPage) {
                if (newPage || perPage != this.paging.perPage) {
                    if (newPage) {
                        this.paging.current = newPage;
                    }
                    this.paging.perPage = perPage;

                    this.getCategories();
                }
            }
        },
        mounted: function () {
            this.init();
        },
        props: {
            showFilters: {
                default: null,
                type: Object
            },
            showPaging: {
                default: false,
                type: Boolean
            },
            showSort: {
                default: false,
                type: Boolean
            }
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/WallpaperCategoriesList.vue